module.exports = __webpack_public_path__ + "static/mcsa-web-applications-certified-2016-cd74becc13adc3d4e30178143fd40552.png";